import { getMaticCount } from "@/cart/displayCart";
import { syncMaticReferralReward } from "@/cart/maticReferralReward";
import { getFirstReferralCode } from "@/cart/referralCode";
import type { CartStateGetSet } from "@/cart/types";
import GRAPHQL_CLIENT from "@/graphql/client";
import type { Cart } from "@/graphql/storefront/generated";

export const initializeCart = ({ set, get }: CartStateGetSet) => {
  const syncReferralReward = syncMaticReferralReward({ set, get });

  return async () => {
    const { cartId, referralCode } = get();
    if (!cartId) return;

    const { cart } = await GRAPHQL_CLIENT.GetCart({ cartId });
    if (!cart) {
      set({
        cartId: undefined,
        cart: undefined,
        referralCode: undefined,
      });
      return;
    }

    const nextCart = cart as Cart;
    const cartReferralCode = getFirstReferralCode(nextCart);

    set({
      cartId: nextCart.id,
      cart: nextCart,
      referralCode: cartReferralCode || referralCode,
    });

    // A saved cart keeps whatever pass its code gave when it was built, so
    // bring it in line with what the code gives today.
    if (cartReferralCode && getMaticCount(nextCart) > 0) {
      try {
        await syncReferralReward(nextCart);
      } catch (error) {
        console.error("Failed to sync referral reward on cart load:", error);
      }
    }
  };
};
